<template>
  <div class="grid-x grid-margin-x">
    <div class="cell large-3 small-7 medium-3 padding-bottom-xxs margin-bottom-s">
      <picture>
        <source :srcset="propsCardImgAvif" type="image/avif" />
        <source :srcset="propsCardImgWebp" type="image/webp" />
        <img :src="propsCardImg" :alt="CREDIT_CARD.heading" />
      </picture>
    </div>
    <div class="cell grid-y large-4 small-12 medium-4 margin-bottom-s add-card" :class="brand === 'bcom' ? 'align-justify' : 'align-start'">
      <p class="margin-bottom-xxs" :class="brand === 'bcom' ? 'h5' : 'large'">
        {{ CREDIT_CARD.emptyCard.title }}
      </p>
      <p :class="['margin-bottom-s', brand === 'bcom' ? 'medium-margin-bottom-xxxl' : 'medium-margin-bottom-l']">
        {{ CREDIT_CARD.emptyCard.description }}
      </p>
      <div :class="brand === 'bcom' && 'medium-margin-bottom-m'">
        <CitiRedirectLink :action="'addcard'" :css="['primary', 'button', 'expanded']" :fire-tag-link="CREDIT_CARD.emptyCard.addTagLink">
          <template #citi-link-content>
            {{ CREDIT_CARD.emptyCard.addCardLabel }}
          </template>
        </CitiRedirectLink>
      </div>
    </div>
    <div class="cell grid-y large-4 small-12 medium-4 align-justify margin-bottom-s">
      <p
        class="margin-bottom-xxs"
        :class="brand === 'bcom' ? 'h5' : 'large'"
        v-html="brand === 'bcom' ? CREDIT_CARD.emptyCard.openCardOffer.title : CREDIT_CARD.emptyCard.openCardOffer.title(discountPercentage)"
      ></p>
      <p
        class="margin-bottom-s medium-margin-bottom-xs"
        v-html="
          brand === 'mcom' ? CREDIT_CARD.emptyCard.openCardOffer.description : CREDIT_CARD.emptyCard.openCardOffer.description(discountPercentage)
        "
      ></p>
      <p v-if="brand === 'bcom'" class="gray-1-color margin-bottom-xs small">
        {{ CREDIT_CARD.emptyCard.openCardOffer.subjectToApprovalLabel }}
        <a :href="CREDIT_CARD.emptyCard.openCardOffer.exclusionsUrl" target="_blank">{{
          CREDIT_CARD.emptyCard.openCardOffer.exclusionsLabel(discountPercentage)
        }}</a>
      </p>
      <CitiRedirectLink
        v-if="brand === 'bcom'"
        :action="'applynow'"
        :css="['secondary', 'button', 'expanded', 'learn-apply']"
        :fire-tag-link="CREDIT_CARD.emptyCard.addTagLink"
      >
        <template #citi-link-content> Apply Now </template>
      </CitiRedirectLink>
      <a v-else :href="CREDIT_CARD.emptyCard.openCardOffer.learnUrl" class="button secondary expanded learn-apply">
        {{ CREDIT_CARD.emptyCard.openCardOffer.learnLabel }}
      </a>

      <p v-if="brand === 'mcom'" class="gray-1-color margin-top-xs small">
        <sup>*</sup>{{ CREDIT_CARD.emptyCard.openCardOffer.subjectToApprovalLabel }}
        <a class="gray-1-color" :href="CREDIT_CARD.emptyCard.openCardOffer.exclusionsUrl">
          {{ CREDIT_CARD.emptyCard.openCardOffer.exclusionsLabel() }}
        </a>
      </p>
      <a v-if="brand === 'bcom'" :href="CREDIT_CARD.emptyCard.openCardOffer.learnUrl" class="margin-top-xs learn-apply">{{
        CREDIT_CARD.emptyCard.openCardOffer.learnLabel
      }}</a>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia';
import { CREDIT_CARD, brand } from 'config';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';
import { useWalletStore } from '@/stores/useWalletStore';
import CitiRedirectLink from '../citiRedirect/CitiRedirectLink';

const envPropsStore = useEnvPropsStore();
const walletStore = useWalletStore();
const { nuxtAppCDNUrl, deviceType } = storeToRefs(envPropsStore);

const propsCardImg = computed(() => {
  const imageName = CREDIT_CARD.emptyCard.propsCardImage;
  return imageName ? `${nuxtAppCDNUrl.value}/img/${imageName}` : '';
});
const propsCardImgWebp = computed(() => {
  return propsCardImg.value ? propsCardImg.value.replace(/\.png$/, '.webp').replace(/\.jpg$/, '.webp') : '';
});
const propsCardImgAvif = computed(() => {
  return propsCardImg.value ? propsCardImg.value.replace(/\.png$/, '.avif').replace(/\.jpg$/, '.avif') : '';
});
const discountPercentage = computed(() => walletStore.discountPercentage);

onBeforeMount(() => {
  walletStore.fetchDiscountDetails({ deviceType });
});
</script>
